var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offer-simple"},[_vm._t("offer-simple")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }